module.exports = __webpack_public_path__ + "img/logo_obg.d0d3e595.png";